@import '~style-sheet-helpers/core.less';

.provider-settings-modal {
  height: 780px;
  width: 780px;
}

.modal-body {
  height: 100%;
  overflow: hidden;
}

.modal-body.iframe-mode {
  div,
  iframe {
    border: 0;
    height: 100%;
    width: 100%;
  }
}
